var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contact-us"},[_c('div',{staticClass:"top"},[_c('img',{staticClass:"logo",attrs:{"src":_vm.logo,"alt":""}}),_c('div',{staticClass:"logo-text"},[_vm._v("Communicate. Collaborate. Create.")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }